module.exports = __webpack_public_path__ + "img/1330954415.17cf321c.jpg";